import React from "react";
import { artists } from "../data";

export default function FeaturedArtists() {
  return (
    <section className="mu-section mu-section-lavender">
      <div className="container">
        <div className="section-head-row">
          <div>
            <div className="mu-eyebrow" style={{ color: "var(--mu-purple-700)" }}>The Lineup</div>
            <h2 className="section-title">Featured Artists</h2>
            <p className="section-sub">
              Meet talented artists shaping today's sound. Explore their music, stories,
              achievements, and latest releases.
            </p>
          </div>
          <a href="#artists" className="btn-mu-outline">Discover More Artists &rarr;</a>
        </div>

        <div className="row g-4">
          {artists.map((a, i) => (
            <div className="col-6 col-lg-3" key={i}>
              <div className="artist-card">
                <div className="artist-avatar">
                  <img src={a.img} alt={a.name} />
                </div>
                <div className="artist-name">{a.name}</div>
                <div className="artist-meta">{a.meta}</div>
                <button className="btn-mu-dark">View Profile</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
